import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import { v4 as uuidv4 } from 'uuid';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';

import { Autocomplete, Box, Card, CircularProgress, FormControl, Grid, MenuItem, Modal, Select, Stack, TextField } from '@mui/material';
import axiosInstance from '../../api/axiosInstance';
import moment from 'moment/moment';
import axios from 'axios';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '1px solid #000',
    borderRadius: "4px",
    boxShadow: 24,
    p: 4,
    textAlign: "center"
};


const NewBusiness = ({ setOpen, getData, toEditRow, setToEditRow, setSnackbarMsgType, setOpenSnackBar, users }) => {

    const [editMode, setEditMode] = useState(false)


    const handleClose = () => {
        setOpen(false);
    };
    const [selectedUser, setSelectedUser] = useState(null)
    const [name, setName] = useState("");
    const [status, setStatus] = useState(null);
    const [nipt, setNipt] = useState(null);
    const [password, setPassword] = useState("")
    const [openPass, setOpenPass] = useState(false)


    useEffect(() => {
        if (toEditRow != null) {
            setEditMode(true)
            setName(toEditRow.name)
            setStatus(toEditRow.status)


        }

    }, [toEditRow])


    const [loading, setLoading] = useState(false)
    const handleNewBusiness = async (e) => {
        e.preventDefault();
        setLoading(true)
        const data = {
            business: {
                "name": name,
                "status": status,
                "vhost": "",
                "createDate": moment(new Date).format('YYYY-MM-DDTHH:mm:ss[Z]'),
                "userId": selectedUser.userid,
                "User": null,
                "nipt": nipt
            },
            password
        }
        try {
            await axiosInstance.post("/business", data)
            getData()
            setOpen(false)
            setOpenPass(false)
            setOpenSnackBar(true)
            setSnackbarMsgType({
                message: "Business Added Successfully",
                type: "success"
            })
        } catch (err) {
            console.log(err)
            setOpenSnackBar(true)
            setSnackbarMsgType({
                message: err.response.data,
                type: "error"
            })
        } finally {
            setLoading(false)
        }
    }
    const handleUpdateBusiness = async (e) => {
        e.preventDefault();

        setLoading(true)
        try {
            await axiosInstance.put("/business", {
                "businessId": toEditRow.businessId,
                "name": name,
                "status": status,
                "vhost": toEditRow.vHost,
                "nipt": nipt

            })
            setToEditRow(null)
            getData()
            setOpen(false)
            setOpenSnackBar(true)
            setSnackbarMsgType({
                message: "Business Updated Successfully",
                type: "success"
            })
        } catch (err) {
            console.log(err)
            setOpenSnackBar(true)
            setSnackbarMsgType({
                message: "Cant update the business",
                type: "success"
            })
        } finally {
            setLoading(false)
        }
    }


    return (
        <div>
            <Dialog
                fullScreen
                open={true}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>

                        <Button autoFocus variant='contained' color="error" onClick={handleClose}>
                            Close
                        </Button>
                    </Toolbar>
                </AppBar>
                <Box display={"flex"} alignItems={"center"} justifyContent={"center"} flexDirection={"column"} sx={{ height: "100%" }} >
                    <Card sx={{ maxWidth: "600px", p: 3, width: "100%" }}>
                        <Box textAlign={"center"} sx={{ my: 4 }}>
                            <Typography sx={{ fontSize: "24px", fontWeight: 700 }}>{editMode ? "UPDATE" : "CREATE"}  BUSINES</Typography>
                            <Typography sx={{ fontSize: "14px", fontWeight: 500 }}>Te gjitha fushat jane te detyruara!</Typography>
                        </Box>
                        <Grid container spacing={2} >
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Box>
                                    <Typography>Zgjidh perdoruesin</Typography>
                                    <Autocomplete
                                        options={users}
                                        id="select-user"
                                        value={selectedUser}
                                        onChange={(_, value) => setSelectedUser(value)}
                                        fullWidth
                                        getOptionLabel={op => op.username}
                                        size='small'
                                        renderInput={(params) => <TextField {...params} />}
                                    />
                                </Box>
                            </Grid>
                            {
                                selectedUser != null ?
                                    <>
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <Box>
                                                <Typography>Business name</Typography>
                                                <TextField value={name} size='small' sx={{ width: "100%" }} onChange={e => setName(e.target.value)} />
                                            </Box>
                                        </Grid>
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <Box>
                                                <Typography>Business Nipt</Typography>
                                                <TextField value={nipt} size='small' sx={{ width: "100%" }} onChange={e => setNipt(e.target.value)} />
                                            </Box>
                                        </Grid>
                                        <Grid item lg={12} md={12} sm={12} xs={12}>
                                            <Box>
                                                <Typography>Status</Typography>
                                                <FormControl fullWidth size='small'>
                                                    <Select
                                                        id="demo-simple-select"
                                                        value={status}

                                                        onChange={e => setStatus(e.target.value)}
                                                    >
                                                        {
                                                            ["Active", "Inactive"].map((el, i) => {
                                                                return (
                                                                    <MenuItem key={i} value={i}>{el}</MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Box>
                                        </Grid>
                                        <Grid item lg={12} md={12} sm={12} xs={12} display={"flex"} justifyContent={"center"}>
                                            <Button disabled={loading} onClick={() => {
                                                if (status != null && name != null) {
                                                    setOpenPass(true)
                                                }
                                            }} color='primary' variant='contained'>
                                                {
                                                    loading ? <CircularProgress /> : "RUAJ"
                                                }
                                            </Button>
                                        </Grid>
                                    </> : ""
                            }

                        </Grid>
                    </Card>
                </Box>

            </Dialog>
            <Modal
                open={openPass}
                onClose={() => setOpenPass(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} component={"form"} onSubmit={(e) => {
                    editMode ? handleUpdateBusiness(e) : handleNewBusiness(e)
                }}>
                    <Typography sx={{ mb: 2 }} id="modal-modal-title" variant="h6" component="h2">
                        Vendos passwordin per "{selectedUser?.username}"
                    </Typography>
                    <TextField inputProps={{
                        autocomplete: 'new-password',
                        form: {
                            autocomplete: 'off',
                        },
                    }} type='password' value={password} onChange={e => setPassword(e.target.value)} size='small' sx={{ my: 2 }} />

                    <Stack direction={"row"} justifyContent={"center"} spacing={1}>
                        <Button type='submit' disabled={loading} color='info' variant='contained' >
                            OK
                        </Button>
                        <Button onClick={handleClose} color='error' variant='contained'>
                            Cancel
                        </Button>
                    </Stack>
                </Box>
            </Modal>

        </div>
    )
}

export default React.memo(NewBusiness, (p, n) => {
    return p.users === n.users && p.toEditRow === n.toEditRow
})